export default __webpack_public_path__ + "static/timeline-02-7fe0089656128b719e340df812e536de.svg";